import { components } from 'react-select';

import ArrowDown from './ArrowDown';

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <ArrowDown />
    </components.DropdownIndicator>
  );
};

export default DropdownIndicator;
